/**
 * Derives an error-codes object from a messages record. Each key in the
 * source maps to itself as a string value, giving type-safe constants
 * without manual duplication.
 *
 * @example
 * ```typescript
 * const MESSAGES = { NOT_FOUND: 'Resource not found', INVALID: 'Invalid input' } as const;
 * const ERROR_CODES = createErrorCodes(MESSAGES);
 * // { NOT_FOUND: 'NOT_FOUND', INVALID: 'INVALID' }
 * ```
 */
export function createErrorCodes<T extends Record<string, unknown>>(
  messages: T,
): { [K in keyof T]: K } {
  return (Object.keys(messages) as Array<keyof T & string>).reduce(
    (acc, key) => Object.assign(acc, { [key]: key }),
    {} as { [K in keyof T]: K },
  );
}
